import { z } from 'zod'

/**
 * Who pays for an organization: the one person who can change its card, see its
 * invoices, cancel or resubscribe. Always an active organization admin of that
 * organization. See `docs/billing-owner.md`.
 */
export const billingOwnerDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string().email(),
})

export type BillingOwnerDto = z.infer<typeof billingOwnerDtoSchema>

/** The people billing could be handed to: the organization's other active organization admins. */
export const billingOwnerListDtoSchema = z.object({
  candidates: z.array(billingOwnerDtoSchema),
})

export type BillingOwnerListDto = z.infer<typeof billingOwnerListDtoSchema>
